import { Post } from '@/types';
import Fields, { resolveFields } from '@/components/frontend/Fields';
import ContentSection from '@/components/frontend/ContentSection';
import ArticleLayout, {
  FieldsLayout,
} from '@/components/frontend/ArticleLayout';
import Hero from '@/components/frontend/Hero';
import { sectionPadding } from '@/components/frontend/FullSection';
import { splitFields } from './Page';

const PlainPage = ({
  fields,
  post_title: title,
  post_excerpt: leadText,
  featured_image,
}: Post) => {
  const [hero, contentFields] = resolveFields(fields);
  const { basicFields, sectionFields } = splitFields(contentFields);

  const heroProps = hero
    ? {
        title: hero.heading || title,
        leadText: hero.text || leadText,
        image: hero.image || featured_image,
      }
    : { title, leadText, image: featured_image };

  return (
    <ArticleLayout noOverlap bg="white">
      <Hero {...heroProps} />
      <FieldsLayout>
        <ContentSection
          gridRowGap={[null, 2, 5, 7]}
          sx={{ '> h2, > h3': { gridColumn: 'aside !important' } }}
          py={sectionPadding}
        >
          <Fields fields={basicFields} />
        </ContentSection>
        <Fields fields={sectionFields} />
      </FieldsLayout>
    </ArticleLayout>
  );
};

export default PlainPage;
